module.exports = __webpack_public_path__ + "static/media/ohne.ccc29740.png";